import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import LoginButton from './LoginButton';

const SmartSchoolButton: FC = () => {
  const { t } = useTranslation();

  const handleNavigate = useCallback(() => {
    const redirectURL = (process.env.REACT_APP_SSO_REDIRECT_URL || '')
      .replace('domain', 'oauth')
      .replace('api_root', process.env.REACT_APP_API_ROOT_V2 || '');
    const absoluteURL = new URL(redirectURL, window.location.origin).href;
    setTimeout(() => {
      window.location.href = absoluteURL;
    }, 0);
  }, []);

  return (
    <LoginButton
      label={t('security.sso.smartSchoolButton.text')}
      handleClick={handleNavigate}
      icon={
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="#FFF"
            d="M137.173 419.054c20.686 12.506 62.056 23.38 102.309 23.38 96.718 0 142.56-51.11 142.56-110.376 0-52.742-31.307-84.822-96.717-108.746-50.316-19.03-72.12-32.08-72.12-60.353 0-21.75 18.45-44.042 62.057-44.042 35.22 0 61.497 10.33 75.473 17.399l16.213-53.83C347.381 72.7 317.751 64 276.94 64c-82.182 0-133.616 45.13-133.616 105.483 0 52.742 39.693 84.822 102.309 106.571 47.52 16.856 66.528 33.167 66.528 60.898 0 29.905-24.599 50.023-68.206 50.023-35.22 0-69.323-10.875-91.127-23.38l-15.654 55.46Z"
          />
        </svg>
      }
    />
  );
};

export default SmartSchoolButton;
